import styles from './brand.module.scss';
import sectionList from '../../../Data/Sections.json';
import Footer from '../../../Components/Footer/Footer';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';
import ProductCard from '../../../Components/ProductCard/ProductCard';
import Loader from '../../../Components/Loader/Loader';

const Brand = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const [currentItem, setCurrentItem] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setLoading(false);
        }, 300);
    }, [id]);

    useEffect(() => {
        const foundItem = sectionList.find((p) => p.id === id);
        setCurrentItem(foundItem);
    }, [id]);

    let productsRender;

    if (currentItem) {
        productsRender = currentItem?.products?.map((product) => {
            return (
                <ProductCard
                    key={product.id}
                    name={product.name}
                    price={product.price}
                    photos={product.photos}
                    onClick={() => navigate(`${product.id}`)}
                />
            );
        });
    }

    return (
        <>
            <div className={styles.placeholder} />
            {loading ? (
                <Loader />
            ) : (
                <>
                    <div className={styles.container}>
                        <h1>{currentItem.brand}</h1>
                        <div className={styles.productsWrapper}>{productsRender}</div>
                    </div>
                </>
            )}
            <Footer />
        </>
    );
};

export default Brand;
